import { render, staticRenderFns } from "./assemblyStorage.vue?vue&type=template&id=77b10e03&scoped=true&"
import script from "./assemblyStorage.vue?vue&type=script&lang=js&"
export * from "./assemblyStorage.vue?vue&type=script&lang=js&"
import style0 from "./assemblyStorage.vue?vue&type=style&index=0&id=77b10e03&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b10e03",
  null
  
)

export default component.exports